import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Flex,
  Heading,
  Text,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { forgotPasswordApi } from "../../api/auth";
import FormInput from "../../components/form/FormInput";
import LayoutView from "../../components/layout";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const forgotPasswordMutation = useMutation(forgotPasswordApi, {
    onSuccess: (response) => {
      setError("");
      setMessage(response.data?.msg);
    },
    onError: (requestError) => {
      setMessage("");
      setError(
        requestError.response?.data?.msg ||
          "Unable to request a password reset. Please try again.",
      );
    },
  });

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string().email("Enter a valid email").required("Required"),
    }),
    onSubmit: (values) => {
      setError("");
      setMessage("");
      forgotPasswordMutation.mutate(values);
    },
  });

  return (
    <LayoutView>
      <Flex align="center" justifyContent="center" minH="60vh">
        <Box
          p={8}
          maxWidth="600px"
          w="full"
          borderWidth={1}
          borderRadius={8}
          boxShadow="lg"
        >
          <Heading textAlign="center" size="lg">
            Forgot password
          </Heading>
          <Text mt="3" textAlign="center" color="gray.600">
            Enter your staff email and we’ll send you a secure reset link.
          </Text>

          {message ? (
            <Box mt="6">
              <Text color="green.600" textAlign="center">
                {message}
              </Text>
              <Button
                mt="6"
                width="full"
                variant="outline"
                onClick={() => navigate("/auth/login")}
              >
                Return to sign in
              </Button>
            </Box>
          ) : (
            <form onSubmit={formik.handleSubmit}>
              <FormInput
                mt="6"
                label="Email"
                type="email"
                id="email"
                placeholder="name@oauife.edu.ng"
                onChange={formik.handleChange("email")}
                value={formik.values.email}
                error={formik.touched.email && formik.errors.email}
                onBlur={formik.handleBlur}
              />
              <Text color="red.500" textAlign="center" mt="2">
                {error}
              </Text>
              <Button
                variant="outline"
                width="full"
                mt="6"
                type="submit"
                isDisabled={forgotPasswordMutation.isLoading}
              >
                {forgotPasswordMutation.isLoading ? (
                  <CircularProgress isIndeterminate size="24px" color="teal" />
                ) : (
                  "Send reset link"
                )}
              </Button>
              <Text
                cursor="pointer"
                textAlign="center"
                mt="5"
                color="#19508d"
                onClick={() => navigate("/auth/login")}
              >
                Back to sign in
              </Text>
            </form>
          )}
        </Box>
      </Flex>
    </LayoutView>
  );
};

export default ForgotPassword;
